export default {
  shares: {
    title: 'User Shares',
    direct: 'Direct Shares',
    indirect: 'Indirect Shares',
    empty: 'No shares found',
    emptyIndirect: 'No indirect shares found',
    userOwnership: 'Your ownership',
    indirectOwnership: 'Your indirect ownership',
    intermediaryCompany: 'Intermediary company',
    loadError: 'Unable to load your shares',
    graphError: 'Unable to display the ownership graph',
    retry: 'Retry',
  },
  form: {
    profileManagement: 'Profile Management',
    myInfo: 'My Info',
    myInfoOverview: 'My Info Overview',
    profilePic: 'Profile Pic',
    legalNameTitle: 'Legal Name & Title',
    designation: 'Designation',
    nationalID: 'National ID',
    nationalIDLength: 'National ID must be 10 characters long',
    phoneNumber: 'Phone Number',
    verified: 'Verified',
    verify: 'Verify',
    emailAddress: 'Email Address',
    address: 'Address',
    zipCode: 'ZIP Code',
    iban: 'IBAN',
    bankName: 'Bank Name',
    about: 'About',
    updateMyInfo: 'Update My Info',
    agree: 'I Agree',
    disagree: 'I Disagree',
    agreementTitle: 'User Agreement',
    agreementContent:
      'By saving your profile, you confirm that all information you provide is true, accurate, and your sole responsibility. Rasmal is not liable for any incorrect, false, or incomplete information you submit.',
  },
};
